import { Component, OnInit } from '@angular/core';
import { Register } from '../../models/register';
import { UserApiService } from 'src/app/dashboard/services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { ApiResponseTable } from 'src/app/dashboard/models/api-response-table';
import { Router } from '@angular/router';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: '.app-register.container-xxl',
  templateUrl: './register.component.html',
  styleUrls: [
    './register.component.css'
  ]
})

export class RegisterComponent implements OnInit {
  constructor(private apiService: UserApiService,
    private router: Router,
    private logger: LoggerService) {

    this.register = new Register();

  }


  public register: Register;
  public loading: boolean = false;
  public apiResponse!: ApiResponseTable;
  public validateMessage: string[] = [];


  ngOnInit() {

  }
  
  public OnSubmit():void {
    this.loading = true;
    try {
      var url = `reguser`;
      var newElement = {
        "firstName": this.register.FirstName,
        "lastName": this.register.LastName,
        "email": this.register.EmailAddress,
        "roleIds": [
          "95942bb8-150d-4be6-9d38-824abafa9aeb"
        ],
        "passwordHash": this.register.Password,
      };
      console.log(JSON.stringify(newElement));
      this.apiService.postWhitoutToken(new ApiRequestModel(url, newElement))
        .subscribe(
          result => {
            this.loading = false;
            this.router.navigateByUrl('/login');
          },
          error => {
            this.loading = false;
            this.validateMessage.push(error.error.text);
          },
          () => {
            console.log(`Completed!`);
          }
        );
    } catch (error) {
      this.logger.addException(error,true);
      this.loading = false;
    }
  }

}
